import React, { Component } from "react";
import { Button } from "design-react-kit";
import {
    BoxDanger,
    BoxSuccess,
    ErrorNotification,
    MnemoLoading,
    SupportoTecnico,
} from "components/misc";
import { CourseHelper, networkErrorHelper, titleRequestService } from "libs";

export class TitleRequestDownloadForm extends Component {

    state = {
        loading: false,
        loadingError: false,
        request: false,
        requestError: '',
        requestResult: '',
        titleRequest: '',
    };

    downloadCertification = () => {

        const { registrationCode } = this.props;

        this.setState({ loading: true });
        titleRequestService.downloadTitle(registrationCode)
            .then(({ data }) => {

                if (data.payload) {

                    const { titleRequestMNEMO, titleRequestGOMP } = data.payload;

                    this.setState({
                        titleRequestMNEMO: titleRequestMNEMO,
                        titleRequestGOMP,
                        loading: false,
                        loadingError: '',
                    });

                    if (titleRequestGOMP.jsonResponse) {

                        const jsonResponse = JSON.parse(titleRequestGOMP.jsonResponse);
                        const requestResult = `data:application/pdf;base64,${jsonResponse.certificateFile.$value}`;
                        const filename = 'conseguimentoTitoloConEsami_' + registrationCode + '.pdf';

                        let a = document.createElement('a');
                        a.href = requestResult;
                        a.download = filename;
                        a.click();
                        this.setState({ requestError: '', request: true });
                    } else {
                        const requestError = "Si è verificato un errore durante l'elaborazione della richiesta. Contattare il supporto tecnico. Dettagli errore: "
                            + data.payload.errors;
                        ErrorNotification.render(requestError, 'errore');
                    }
                }

                this.setState({ loading: false });
            })
            .catch(error => {
                const requestError = "Si è verificato un errore durante l'elaborazione della richeista. Contattare il supporto tecnico. Dettagli errore: " + networkErrorHelper.getErrorMessage(error);
                this.setState({ loading: false, requestError, requestResult: '', request: true });
            });
    }

    downloadPergamena = () => {

        const { registrationCode } = this.props;

        this.setState({ loading: true });
        titleRequestService.downloadPergamena(registrationCode)
            .then(({ data }) => {

                if (data.payload) {

                    const { titleRequestMNEMO, titleRequestGOMP, paymentMnemo } = data.payload;

                    this.setState({
                        titleRequestMNEMO: titleRequestMNEMO,
                        titleRequestGOMP,
                        paymentMnemo: paymentMnemo,
                        loading: false,
                        loadingError: '',
                    });

                    if (titleRequestGOMP.jsonResponse) {

                        const jsonResponse = JSON.parse(titleRequestGOMP.jsonResponse);
                        const requestResult = `data:application/pdf;base64,${jsonResponse.certificateFile.$value}`;
                        const filename = 'pergamena_' + registrationCode + '.pdf';

                        let a = document.createElement('a');
                        a.href = requestResult;
                        a.download = filename;
                        a.click();
                        this.setState({ requestError: '', request: true });
                    } else {
                        const requestError = "Si è verificato un errore durante l'elaborazione della richiesta. Contattare il supporto tecnico. Dettagli errore: "
                            + data.payload.errors;
                        ErrorNotification.render(requestError, 'errore');
                    }
                }

                this.setState({ loading: false });
            })
            .catch(error => {
                const requestError = "Si è verificato un errore durante l'elaborazione della richeista. Contattare il supporto tecnico. Dettagli errore: " + networkErrorHelper.getErrorMessage(error);
                this.setState({ loading: false, requestError, requestResult: '', request: true });
            });
    }

    render() {

        const { paymentMNEMO } = this.props;
        const showPergamena = paymentMNEMO && paymentMNEMO.importPaied ==='40.00' ? true : false;

        
        const { loading, loadingError, request, requestError } = this.state;
        if (loadingError) return (<BoxDanger className="m-5">Si è verificato un errore durante l'elaborazione della richiesta,
            se il problema persiste puoi  <SupportoTecnico /></BoxDanger>);
        return (<>
            {(loading) && (<MnemoLoading />)}
            {(!request) ? (<>
                <p>La Sua richiesta è andata a buon fine.</p>
                <Button color="primary bg-dark" className="mt-4 d-block" onClick={this.downloadCertification}>
                    {(CourseHelper.isOnlyBollo(this.props.courseCode) ? ("Scarica Certificato") : ("Scarica il certificato di conseguimento titolo con esami"))}</Button>
                {(showPergamena) && (
                <Button color="primary bg-dark" className="mt-4 d-block" onClick={this.downloadPergamena}>Scarica la pergamena finale</Button>
                )}
            </>) : (<>
                {(requestError) ? (<>
                    <BoxDanger>{requestError}</BoxDanger>
                </>) : (<>
                    <BoxSuccess>File correttamente generato e scaricato, controlla nei tuoi download</BoxSuccess>
                </>)}
            </>)}
        </>)
    }
}